module.exports = {
      id: "comm-women-usage",
      viewBox: "0 0 228.124 50.336",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-women",
      toString: function () {
        return this.url;
      }
    }